import { useContext, useEffect, useState } from 'react';
import * as Sentry from '@sentry/browser';
import {
  parseFiltersFromQS,
  pushStag,
  // currentIp as fetchCurrentIp,
  // camelize,
  // CurrentIp,
  AuthContext,
} from '@repo-level/core-front';

import { LocalStorage } from 'helpers/localStorage';
import { STAG_PARAMS, CROSS_SALE_STAGS } from 'helpers/conf';
import { sendEventToAnalyticsFn } from 'helpers/analytics';
import { AnalyticsEventName } from 'api/analytics';
import { removeUrlParameters } from 'helpers/common';
// import { checkDomainByLocalization } from 'helpers/domain';

export const localStorageIsStag = new LocalStorage<boolean, boolean>(
  'isStag',
  false
);
export const localStorageStag = new LocalStorage<string, null>('stag', null);

export const localStorageSpecialStag = new LocalStorage<string, null>(
  'specialStag',
  null
);

const getStag = (str?: string) => {
  if (str == null) return;
  return str.match(/^\d+/)?.[0];
};

type QueryString = Partial<{ [x: string]: string | undefined }>;

const setSpecialStags = (queryString: QueryString) => {
  const specialStag = CROSS_SALE_STAGS.find(
    (stag) => stag === getStag(queryString.stag)
  );
  if (specialStag == null) return;
  localStorageSpecialStag.push(specialStag);
};

const checkStag = (queryString: QueryString) => {
  if (queryString.stag) {
    localStorageIsStag.push(true);
    localStorageStag.push(queryString.stag);

    Sentry.setTag('stag', queryString.stag);
  }
};

const pushStagToServer = async (queryString: QueryString) => {
  if (Object.keys(queryString).length === 0) return;
  await pushStag(queryString);
};

const setVisitToAnalytics = async (queryString: QueryString) => {
  if (queryString.stag == null) return;

  const referrer = (() => {
    try {
      if (queryString.referrer == null) return;
      return atob(queryString.referrer);
    } catch {
      return;
    }
  })();

  const stag = getStag(queryString.stag);

  sendEventToAnalyticsFn({
    name: AnalyticsEventName.VISIT,
    attributes: { stag, url: referrer },
  });
};

export function useStag() {
  const { user, pendingUser } = useContext(AuthContext);

  const [isStag, setIsStag] = useState(false);

  useEffect(() => {
    const localStorageIsStag = localStorage.getItem('isStag');

    if (localStorageIsStag != null && localStorageIsStag === 'true') {
      setIsStag(true);
    }
  }, []);

  useEffect(() => {
    if (user?.id != null || pendingUser) return;

    const stag = async () => {
      try {
        // const { data: currentIp } = await fetchCurrentIp()
        //   .then(({ data }) => ({ data: JSON.parse(data) }))
        //   .then(({ data }) => ({ data: camelize(data) as CurrentIp }));
        // checkDomainByLocalization(currentIp);
      } catch (error) {
        if (error != null) {
          Sentry.captureException(error);
        }

        Sentry.captureMessage(
          'Failed to obtain ip address from stag',
          Sentry.Severity.Error
        );
      }

      const queryString = parseFiltersFromQS(
        window.location.search,
        STAG_PARAMS
      );

      if (queryString.stag != null) {
        setIsStag(true);
      }

      setSpecialStags(queryString);

      checkStag(queryString);

      try {
        await setVisitToAnalytics(queryString);
      } catch (error) {
        if (error != null) {
          Sentry.captureException(error);
        }

        Sentry.captureMessage('Analytics sending error', Sentry.Severity.Error);
      }

      try {
        await pushStagToServer(queryString);

        removeUrlParameters(Object.keys(queryString));
      } catch (error) {
        if (error != null) {
          Sentry.captureException(error);
        }

        Sentry.captureMessage('Stag sending error', Sentry.Severity.Error);
      }
    };

    stag();
  }, [user?.id, pendingUser]);

  return { isStag };
}
